import React from "react";
import { Modal, Form, Row, Col, InputNumber, List } from "antd";
import { AntdButton, DatePickerField, InputField, SelectInput } from "../../../blueplanitUtils/InputField";
import { getOptionsByPath } from "../../../utilsdata";
import { ASSET_CATEGORY,ADD_ASSET, ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT } from "../../../Dropdownmanager";
import { useSelector } from "react-redux";
import { handleMultipleAttachment } from "../../../blueplanitUtils/attachments";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { useEffect } from "react";


const EditAssetModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
  selectedAsset,
  editForm,
  AllAssets,
  AttachmentHistory,
  setAttachmentHistory,
  Changedattachment,
  setChangedAttachment,
  currentAttachments,
  setCurrentAttachments,
  fileInputEditRef,
  handleNewAttachmentsUpload,
  handleReplaceAttachment,
  handleDeleteAtta,
  updateAsset,
  loginUser,
  details,
  dispatch,
  id,
  message,
  getAllAssets,
  pagination,
  filters,
  setSelectedAsset,
  setAssetList,
}) => {
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  useEffect(() => {
    if (selectedAsset && isEditModalOpen) {
      editForm.setFieldsValue({
        ...selectedAsset,
        purchaseDate: selectedAsset.purchaseDate
          ? dayjs(
            isNaN(selectedAsset.purchaseDate)
              ? selectedAsset.purchaseDate
              : Number(selectedAsset.purchaseDate)
          )
          : null,
      });
    }
  }, [selectedAsset, isEditModalOpen]);
  return (
    <Modal
      title="Edit Asset"
      open={isEditModalOpen}
      onCancel={() => setIsEditModalOpen(false)}
      onOk={() => {
        if (!selectedAsset) return;

        editForm.validateFields().then(async (values) => {
          const formAssetTagId = values.assetTagId?.trim();
          const isDuplicateTagId = AllAssets?.records?.some(
            (asset) =>
              asset.assetTagId === formAssetTagId &&
              asset.id !== selectedAsset?.id
          );

          if (isDuplicateTagId) {
            message.error(
              "Asset Tag ID already exists. Please use a unique one."
            );
            return;
          }

          const normalizeDate = (val) => {
            if (!val) return "";
            if (typeof val === "string" && !isNaN(Number(val))) {
              // If it's a stringified timestamp
              return dayjs(Number(val)).format("YYYY-MM-DD");
            }
            if (typeof val === "number") {
              // If it's a timestamp
              return dayjs(val).format("YYYY-MM-DD");
            }
            if (typeof val === "string") {
              // If it's a date string
              return dayjs(val).format("YYYY-MM-DD");
            }
            // If it's a dayjs object or Date object
            return dayjs(val).format("YYYY-MM-DD");
          };


          const formValues = {
            ...values,
            purchaseDate: normalizeDate(values.purchaseDate),
            cost: values.cost || 0,
          };

          const original = {
            ...selectedAsset,
            purchaseDate: selectedAsset.purchaseDate
              ? normalizeDate(selectedAsset.purchaseDate)
              : "",
          };

          const hasChanges = Object.keys(formValues).some((key) => {
            const val1 = formValues[key];
            const val2 = original[key];

            if (val1 === undefined && val2 === undefined) return false;
            if (val1 === null && val2 === null) return false;

            return String(val1) !== String(val2);
          });

          let uploaded = [];
          if (currentAttachments.length > 0) {
            uploaded = await handleMultipleAttachment(
              currentAttachments,
              details,
              dispatch,
              id
            );
          }
          const AllAttachment = [...Changedattachment, ...uploaded];
          uploaded = [];
          setChangedAttachment([]);
          setCurrentAttachments([]);
          const cleanedAttachments = AllAttachment?.filter(
            (file) => file.status !== undefined || file.replacedFile
          ).map(({ __typename, id, ...rest }) => rest);
          const originalAttachments = selectedAsset.attachments || [];
          const hasAttachmentChanges = AllAttachment.some((newFile) => {
            const matchedOriginal = originalAttachments.find(
              (orig) => orig.id === newFile.id
            );
            if (!matchedOriginal) return true;
            return (
              matchedOriginal.status !== newFile.status ||
              matchedOriginal.replacedFile !== newFile.replacedFile
            );
          });

          if (!hasChanges && !hasAttachmentChanges) {
            message.info("No changes detected to update.");
            return;
          }

          try {
            const variables = {
              id: selectedAsset.id,
              ...formValues,
              category: values.category || "",
              department: values.department || "",
              assetPhoto: selectedAsset.assetPhoto || "",
              createdBy: selectedAsset.createdBy || "",
              editedBy: `${loginUser?.firstname} ${loginUser?.lastname}`,
              editedAt: Date.now().toString(),
              attachments: cleanedAttachments,
            };

            const data = await dispatch(updateAsset(variables)).unwrap();
            setAssetList((prev) =>
              prev.map((item) => (item.id === data.id ? { ...item, ...data } : item))
            );
            if (data?.id) {
              message.success("Asset updated successfully!");
              setIsEditModalOpen(false);
              setSelectedAsset(data);
              setAttachmentHistory(data.attachments || []);

              dispatch(
                getAllAssets({
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                  ...filters,
                })
              );
            } else {
              message.error("Failed to update asset!");
            }
          } catch (error) {
            message.error("Update failed");
          }
        });
      }}
    >
      <Form layout="vertical" form={editForm}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="assetTagId" label="Asset Tag ID">
              <InputField />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="productName" label="Product Name">
              <InputField />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="purchaseDate" label="Purchase Date">
              <DatePickerField style={{ width: "100%" }} format="DD/MM/YYYY" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="cost" label="Cost">
              <InputNumber style={{ width: "100%" }} prefix="₹" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="brand" label="Brand">
              <InputField />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="model" label="Model">
              <InputField />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="description" label="Description">
              <InputField />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="category" label="Category">
              <SelectInput
                allowClear
                options={getOptionsByPath(NestedDatabucket, [ADD_ASSET, ASSET_CATEGORY])}

              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="department" label="Department">
              <SelectInput
                allowClear
                options={getOptionsByPath(NestedDatabucket,[ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}

              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="purchasedFrom" label="Purchased From">
              <InputField />
            </Form.Item>
          </Col>

          <Form.Item label="Add Attachments">
            <input
              type="file"
              multiple
              ref={fileInputEditRef}
              onChange={(e) => handleNewAttachmentsUpload(e)}
              style={{ display: "none" }}
            />
            <AntdButton
              icon={<FontAwesomeIcon icon={faUpload} />}
              onClick={() =>
                fileInputEditRef.current && fileInputEditRef.current.click()
              }
              label="Upload Files"
            />
          </Form.Item>
          <Col span={24}>
            <Form.Item>
              <List
                dataSource={AttachmentHistory.filter(
                  (file) => file.status === true
                )}
                renderItem={(file, idx) => (
                  <List.Item>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{ flex: 1, textAlign: "left" }}
                      >
                        {file.filename || `File ${idx + 1}`}
                      </span>
                      <div style={{ display: "flex", gap: 12 }}>
                        <FontAwesomeIcon
                          icon={faPen}
                          style={{ color: "#1890ff", cursor: "pointer" }}
                          onClick={(e) =>
                            handleReplaceAttachment(e, file, idx)
                          }
                        />
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "red", cursor: "pointer" }}
                          onClick={() => handleDeleteAtta(file, idx)}
                        />
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditAssetModal;